export default __webpack_public_path__ + "tab1_video_poster_m1b9e81.png";